/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react'
import {
  Button,
  Col,
  Dropdown,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import ShowHistory from '../../../components/employees/pim/data-history'
import {
  getEmpsAPI,
  getEmpsExcelCheck2API,
  getEmpsExcelLog2API
} from '../../../services/employee'
import Error_false from '../../../components/error/error-false'
import {
  BsArrowClockwise,
  BsFileEarmarkArrowUp,
  BsPlusLg,
  BsSearch,
  BsSliders2Vertical
} from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import { PIM_CREATE } from '../../../router/routes'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import NavRoleOrg from '../../../components/nav-role-org'
import { useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import CardCustom from '../../../components/custom/card-custom'
import NavTitle from '../../../components/nav-title'
import { BODY, PAGE } from '../../../Constants'
import PDFExportSignature from '../../../components/employees/pim/pdf-export-signature'
import TextNavTitle from '../../../components/TextNavTitle'
import {
  createShortUrlsLinkAPI,
  getShortUrlsLinkAPI
} from '../../../services/Qlnk'
import Error_500 from '../../../components/error/error-500'
import ModalFilterPim from './ModalFilterPim'
import ExportExcel2 from './ExportExcel2'
import ExportExcel1 from './ExportExcel1'
import ExportExcel3 from './ExportExcel3'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import { useMenuLayoutStore, useOrgSeleteStore } from '../../../store/layout'

function EmpPimPage() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const { orgSelete } = useOrgSeleteStore()

  const { control, setValue, handleSubmit } = useForm()
  const bodyQuery = localStorage.getItem(BODY)
  const pageOld = localStorage.getItem(PAGE)
  const [page, setPage] = useState(pageOld ?? 1)
  const [bodyFilter, setBodyFilter] = useState()

  const [dataEmps, setDataEmps] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(20)
  const navigate = useNavigate()

  const [dataExcel, setDataExcel] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [showFilter, setShowFilter] = useState(false)
  const handleClose = () => setShowFilter(false)
  const handleShow = () => setShowFilter(true)
  const [dataModal, setDataModal] = useState([])

  const { menuLayout } = useMenuLayoutStore()

  const [urlNext, setUrlNext] = useState('')
  const [newMenu, setNewMenu] = useState([])
  const menuData = useMemo(() => menuLayout, [menuLayout])
  useEffect(() => {
    if (menuData.length > 0) {
      const menuMain = menuData.find((item) => item.id === 11)
      if (menuMain) {
        const subMenu = menuMain.submenu.find((item) => item.menuId === 5)

        if (subMenu?.menuSubList.length > 0) {
          setNewMenu(subMenu?.menuSubList)
          setUrlNext(subMenu?.menuSubList[0].link)
        }
      }
    }
  }, [menuData])

  useEffect(() => {
    const d = JSON.parse(bodyQuery)
    setValue('search', d?.searchs)

    if (roleId) {
      setIsLoading(true)
      const body = {
        ...d,
        page: 1,
        orgId: roleId,
        statusId: d?.statusId ?? 1,
        size: d?.size ?? 20
        // statusId: d?.statusId ?? 1
      }
      setPage(1)
      getEmps(body)
      getEmpsExcelCheck()
    }
  }, [roleId])

  const getEmps = async (body) => {
    setPage(body.page)
    setBodyFilter(body)
    setIsLoading(true)
    localStorage.setItem(BODY, JSON.stringify(body))
    const data = await getEmpsAPI(body)
    setIsLoading(false)
    if (!data) return
    if (data.status) {
      setDataEmps(data.result)
      setTotalRows(data.totalRows)
      setTotalLimits(data.totalLimits)
    } else {
      Error_false(data)
      setTotalRows(0)
      setTotalLimits(20)
    }
    handleClose()
  }

  const getEmpsExcelCheck = async () => {
    setIsLoading(true)
    const data = await getEmpsExcelCheck2API()
    setIsLoading(false)
    if (!data) return
    if (data.status) {
      data.result.length > 0 && setDataExcel(data.result)
    } else {
      setDataExcel([])
    }
  }

  const createEmpsExcelLog2 = async (typeId) => {
    const data = await getEmpsExcelLog2API({ typeId: typeId })
    setIsLoading(false)
    if (!data) return
  }

  const clearSearch = () => {
    const body = {
      page: 1,
      orgId: roleId,
      statusId: 1
      // size: 2
    }
    setValue('search', '')
    setPage(1)
    setBodyFilter(body)
    localStorage.setItem(BODY, '{}')
    localStorage.setItem(PAGE, 1)
    getEmps(body)
  }

  const fnCleckDetail = (d) => {
    // urlNext &&
    //   navigate(
    //     {
    //       pathname: urlNext + '/' + d.uuid,
    //       search: `?${createSearchParams({
    //         orgId: d.org_id,
    //         code: d.code,
    //         name: `${d.title_en} ${d.name_en} ${d.surname_en}`,
    //         username: `${d.username}`,
    //         uuid: d.uuid
    //       })}`
    //     },
    //     { replace: false }
    //   )
    urlNext &&
      navigate(
        {
          pathname: urlNext + '/' + d.uuid
        },
        { replace: false }
      )
  }

  const fnCheckMenuExcel = (d) => {
    switch (d.type_id) {
      case 1:
        return (
          <>
            <ExportExcel1
              type_name={d.type_name}
              parame={{
                ...bodyFilter,
                page: 1,
                orgId: roleId,
                size: totalRows
              }}
              createEmpsExcelLog2={createEmpsExcelLog2}
            />
          </>
        )
      case 2:
        return (
          <>
            <ExportExcel2
              type_name={d.type_name}
              parame={{
                ...bodyFilter,
                page: 1,
                orgId: roleId,
                size: totalRows
              }}
              createEmpsExcelLog2={createEmpsExcelLog2}
            />
          </>
        )
      case 3:
        return (
          <>
            <PDFExportSignature
              typeName={d.type_name}
              body={bodyFilter}
              createEmpsExcelLog2={createEmpsExcelLog2}
            />
          </>
        )
      case 12:
        return (
          <>
            <ExportExcel3
              type_name={d.type_name}
              parame={{
                ...bodyFilter,
                page: 1,
                orgId: roleId,
                size: totalRows
              }}
              createEmpsExcelLog2={createEmpsExcelLog2}
            />
          </>
        )
      default:
        return <></>
    }
  }

  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: d.search ?? ''
    }
    getEmps(body)
    setPage(1)
  }

  const createShortUrlsLink = async () => {
    const longUrl = `https://staff.skyict.co.th/card2/${dataModal.uuid}`
    const data = await createShortUrlsLinkAPI({ longUrl })
    if (!data) return

    getShortUrlsLink()
  }

  const getShortUrlsLink = async () => {
    try {
      createEmpsExcelLog2(8)

      const searchTerm = `https://staff.skyict.co.th/card2/${dataModal.uuid}`
      const res = await getShortUrlsLinkAPI({ searchTerm })
      if (!res) return
      if (!res.shortUrls.data[0]?.shortUrl) {
        setDataModal(res.shortUrls.data[0]?.shortUrl)

        createShortUrlsLink()
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <>
      <Row>
        <NavTitle>
          <TextNavTitle>PIM</TextNavTitle>
        </NavTitle>
        <NavRoleOrg />

        <Col xl={12} className="mb-3">
          <div className="p-3 bg-white rounded-top-3 shadow-sm">
            <Row>
              <Col
                xl={2}
                className="my-auto d-flex gap-3 justify-content-between"
                style={{ flexWrap: 'wrap' }}
              >
                <label
                  className=" my-auto fw-bold"
                  style={{
                    fontSize: '14px'
                  }}
                >
                  Total: {totalRows?.toLocaleString()}
                </label>
              </Col>
              <Col xl={10}>
                <Row className="g-2">
                  <Col lg={6} className="my-auto">
                    <Form onSubmit={handleSubmit(onSearch)}>
                      <Form.Group className="" style={{ width: '100%' }}>
                        <Controller
                          name={'search'}
                          control={control}
                          render={({ field: { onChange, value = '' } }) => (
                            <InputGroup className="">
                              <InputGroup.Text className="bg-white border-end-0  text-muted">
                                <BsSearch />
                              </InputGroup.Text>
                              <Form.Control
                                value={value}
                                placeholder="Code/ Username/ Name/ ID Card/ PersonID"
                                onChange={onChange}
                                className="border-start-0 ps-0 placeholder-text"
                              />
                            </InputGroup>
                          )}
                        />
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col lg={2}>
                    <div className="d-flex gap-2 ">
                      <Button
                        onClick={handleShow}
                        className=" text-primary d-flex border-0 w-100"
                        type="button"
                        variant="light"
                      >
                        <div className="my-auto me-2">
                          <BsSliders2Vertical />{' '}
                        </div>{' '}
                        Filter
                      </Button>

                      <Button
                        type="button"
                        variant="light"
                        onClick={() => clearSearch()}
                        className="text-primary border-0 "
                      >
                        <BsArrowClockwise />
                      </Button>
                    </div>
                  </Col>

                  {dataExcel.length > 0 && (
                    <Col lg={2}>
                      <Dropdown className="w-100 ">
                        <Dropdown.Toggle
                          // size="sm"
                          variant="primary"
                          className="w-100 "
                          id="dropdown-basic"
                        >
                          <BsFileEarmarkArrowUp className="me-2" />
                          Export
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {dataExcel.map((d) => fnCheckMenuExcel(d))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  )}

                  {orgSelete?.status_id === 1 && (
                    <Col lg={2}>
                      <div className="d-flex gap-2 ">
                        <Button
                          onClick={() => navigate(PIM_CREATE)}
                          className="w-100  btn-primary border-0"
                        >
                          <BsPlusLg className="me-2" />
                          Add Employee
                        </Button>
                      </div>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </div>
          <CardCustom
            minHeight=""
            className="d-flex justify-content-between "
            style={{
              height: 'calc(100vh - 190px)'
            }}
          >
            <Table responsive hover className="mb-3">
              <thead
                className="bg-hrms text-white "
                style={{ position: 'sticky', top: '0px', zIndex: 999 }}
              >
                <tr className=" font-title-table">
                  <th
                    className="fw-normal "
                    style={{
                      whiteSpace: 'nowrap',
                      minWidth: '40px'
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{ whiteSpace: 'nowrap', width: '50px' }}
                    className="text-center fw-normal"
                  >
                    Image
                  </th>
                  <th
                    className="fw-normal"
                    style={{
                      whiteSpace: 'nowrap',
                      minWidth: '100px',
                      maxWidth: '100px'
                    }}
                  >
                    Code
                  </th>
                  <th
                    className="fw-normal"
                    style={{ whiteSpace: 'nowrap', minWidth: '90px' }}
                  >
                    Start Date
                  </th>
                  <th
                    className="fw-normal"
                    style={{ whiteSpace: 'nowrap', minWidth: '200px' }}
                  >
                    Name
                  </th>
                  <th
                    className="fw-normal"
                    style={{ whiteSpace: 'nowrap', maxWidth: '80px' }}
                  >
                    Nickname
                  </th>
                  <th
                    className="fw-normal text-center"
                    style={{ whiteSpace: 'nowrap', maxWidth: '80px' }}
                  >
                    Group
                  </th>
                  <th
                    className="fw-normal text-center"
                    style={{ whiteSpace: 'nowrap', maxWidth: '100px' }}
                  >
                    Department
                  </th>
                  <th
                    className="fw-normal"
                    style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
                  >
                    Team
                  </th>
                  <th
                    className="fw-normal"
                    style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
                  >
                    Position
                  </th>

                  <th
                    className="fw-normal"
                    style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
                  >
                    Type
                  </th>
                  <th
                    className="fw-normal"
                    style={{ whiteSpace: 'nowrap', minWidth: '190px' }}
                  >
                    Email/ Phone No.
                  </th>
                  <th
                    className="fw-normal text-center"
                    style={{ whiteSpace: 'nowrap', maxWidth: '50px' }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="text-break fw-light">
                {isLoading ? (
                  <TableSkeletonBody colSpan={13} rowSpan={10} />
                ) : (
                  <>
                    {dataEmps.length > 0 ? (
                      dataEmps.map((d, i) => (
                        <ShowHistory
                          key={i}
                          isLoading={isLoading}
                          page={page}
                          totalLimits={totalLimits}
                          data={dataEmps}
                          d={d}
                          i={i}
                          urlNext={urlNext}
                          fnCleckDetail={fnCleckDetail}
                          newMenu={newMenu}
                        />
                      ))
                    ) : !roleId ? (
                      <tr className="mb-0">
                        <td className="text-center small" colSpan={13}>
                          - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
                        </td>
                      </tr>
                    ) : (
                      <tr className="mb-0">
                        <td className="text-center" colSpan={13}>
                          -ไม่มีข้อมูล-
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </Table>
            {/* <p>{showFilter.toString()}</p> */}
            <div className="pt-3">
              <PaginationControl
                page={page}
                total={totalRows}
                limit={totalLimits}
                changePage={(p) => {
                  const body = {
                    ...bodyFilter,
                    page: p
                    // size: 2
                  }
                  localStorage.setItem(PAGE, p)
                  getEmps(body)
                  setPage(p)
                }}
                ellipsis={1}
              />
            </div>
          </CardCustom>
        </Col>
      </Row>

      {showFilter && (
        <ModalFilterPim
          open={showFilter}
          onCancel={handleClose}
          getEmps={(d) => {
            getEmps({ ...bodyFilter, ...d })
          }}
          roleId={roleId}
          isLoading={isLoading}
        />
      )}
    </>
  )
}

export default EmpPimPage
